
import React from 'react'
import icon from './svgs/section.svg'
import { BaseIcon } from './_base'

export const SectionIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size:size || '70px',...sx}} />
    )
}
